import { useEffect, useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import BrandMark from './BrandMark';
import './Nav.css';

/* Nav.tsx — site header: brand mark, mailto link, theme toggle.
   The mailto link (.nav__mail) is a plain underlined link with a
   trailing arrow glyph, same shape as the .btn arrow in Landing.tsx. */

const Arrow = () => (
  <svg className="arrow" width="14" height="10" viewBox="0 0 14 10" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M1 5h11M8.5 1.5 12 5l-3.5 3.5" />
  </svg>
);

const Sun = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M19.1 4.9l-1.4 1.4M6.3 17.7l-1.4 1.4" />
  </svg>
);

const Moon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
  </svg>
);

const Nav = () => {
  const { theme, toggleTheme } = useTheme();
  const [stuck, setStuck] = useState(false);

  useEffect(() => {
    const onScroll = () => setStuck(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={`nav ${stuck ? 'is-stuck' : ''}`}>
      <div className="wrap nav__in">
        <a className="brand" href="/" aria-label="Blockworks home">
          <BrandMark size={30} />
          <span>Blockworks</span>
        </a>

        <div className="nav__right">
          <a className="nav__mail" href="mailto:hello@blockworks.dev">
            hello@blockworks.dev
            <Arrow />
          </a>
          <button
            className="iconbtn"
            type="button"
            onClick={toggleTheme}
            aria-label={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
          >
            {theme === 'dark' ? <Sun /> : <Moon />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
